export default class SetAltTextForImg {
    static init(): void {
       // Funkce pro získání textu z prvku h1 a nastavení textu jako ALT u obrázků
        function setAltTextForImages(): void {
            const headerElement = document.querySelector<HTMLHeadingElement>('.section--header h1.h1--caption');
            
            if (headerElement) {
                const text: string = headerElement.textContent?.trim() || '';
                const images: NodeListOf<HTMLImageElement> = document.querySelectorAll('.technology-header-slider__img img');
                
                images.forEach((img, index) => {
                    if (images.length > 1) {
                        img.alt = `IMG: ${text} ${index + 1}`;
                    } else {
                        img.alt = `IMG: ${text}`;
                    }
                });
            }
        }
        setAltTextForImages();
    }
}